import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import Header from "../../component/organisms/header";
import MainLayout from "../../component/atoms/layout/mainLayout";
import Sidebar from "../../component/organisms/sidebar";
import TableLayout from "../../component/atoms/layout/table/tableLayout";
import TableTitle from "../../component/atoms/text/table/tableTitle";
import TableTop from "../../component/atoms/layout/table/tableTop";
import TableSearchBtn from "../../component/atoms/layout/table/tableSearchBtn";
import TableCount from "../../component/molecules/tableCount";
import SearchBar from "../../component/atoms/input/searchBar";
import Table from "../../component/atoms/layout/table/table";
import Tr from "../../component/atoms/layout/table/tr";
import Th from "../../component/atoms/layout/table/th";
import Td from "../../component/atoms/layout/table/td";
import Pagenation from "../../component/molecules/pagenation";
import { toast } from "react-toastify";
import { toastMsg } from "../../util/toastMsg";
import moment from "moment";
import Modal from "../../component/templates/Modal";
import { errorHandler } from "../../util/error-handler";
import { route } from "../../router/route";
import ThText from "../../component/atoms/text/table/thText";
import TdText from "../../component/atoms/text/table/tdText";
import DetailBtn from "../../component/atoms/button/detailBtn";
import { modalMsg } from "../../util/modalMsg";
import AddBtn from "../../component/atoms/button/addBtn";
import AlarmApi from "../../api/alarmApi";
import TableTab from "../../component/molecules/tableTab";
import { useRecoilState } from "recoil";
import { osTabState } from "../../recoil/tabState";
import Checkbox from "../../component/atoms/input/checkbox";
import DelBtn from "../../component/atoms/button/delBtn";
import TableFilterManager from "../../component/atoms/layout/table/tableFilterManager";
import StoryApi from "../../api/storyApi";

function Story(props) {
  const navigate = useNavigate();
  const location = useLocation();
  const [tab, setTab] = useState("");

  const [delId, setDelId] = useState(-1);
  const [delIdList, setDelIdList] = useState([]);
  const [delListModalOpen, setDelListModalOpen] = useState(false);
  const [delModalOpen, setDelModalOpen] = useState(false);

  const { page } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const [pagination, setPagination] = useState({
    size: 10, // 한 페이지에 표시될 게시글 수
    rangeSize: 5, // 하단 페이지 사이즈

    totalCount: 0,
    totalPages: 0,
    first: false,
    last: false,
  });
  const [list, setList] = useState([]);
  const [keyword, setKeyword] = useState("");

  useEffect(() => {
    setKeyword(searchParams.get("keyword") ? searchParams.get("keyword") : "");
    setTab(searchParams.get("tab") ? searchParams.get("tab") : "");
    getList();
  }, [location, tab]);

  const getList = async () => {
    try {
      const data = {
        keyword: searchParams.get("keyword"),
        page: page - 1,
        size: pagination.size,
        regionCodeTag: "",
      };
      let list = (await StoryApi.Get(data)).data.data;

      setList(list.content.map((item) => ({ ...item, regionName: getRegionName(item.regionCodeTag, item.regionNameTag) })));
      setPagination({
        ...pagination,
        totalCount: list.totalElements,
        totalPages: list.totalPages,
        first: list.first,
        last: list.last,
      });
    } catch (error) {
      errorHandler(error);
    }
  };

  const deleteFunc = async () => {
    try {
      const formData = new FormData();
      for (let index = 0; index < delIdList.length; index++) {
        const element = delIdList[index];
        formData.append("idList", element.id);
      }

      await StoryApi.DelChecked(formData);
      toast(toastMsg.delete);
      setDelListModalOpen(false);
      setDelIdList([]);
      getList();
    } catch (error) {
      errorHandler(error);
    }
  };

  const [filterOpen, setFilterOpen] = useState(-1);
  const [activeId, setActiveId] = useState(null);
  const [activeModalOpen, setActiveModalOpen] = useState(false);
  const [deactiveModalOpen, setDeactiveModalOpen] = useState(false);

  const activeFunc = async (activation) => {
    try {
      const data = {
        activation: activation,
      };
      await StoryApi.Activate(activeId, data);
      toast(toastMsg.create);
      setFilterOpen(-1);
      setActiveModalOpen(false);
      setDeactiveModalOpen(false);
      getList();
    } catch (error) {
      errorHandler(error);
    }
  };

  const getRegionName = (regionCodeTag, regionNameTag) => {
    if (regionCodeTag === "#99999") {
      return "전국";
    } else {
      return regionNameTag.split("#").filter(Boolean).join("<br/>");
    }
  };

  return (
    <>
      <Header />
      <MainLayout>
        <Sidebar />
        <TableLayout>
          <TableTitle>O’s life 관리</TableTitle>
          <TableTab
            onClick={(type) => {
              if (type === "USER") {
                navigate(`${route.story}/1?tab=${type}`);
              } else {
                navigate(`${route.os_pick}/1?tab=${type}`);
              }
            }}
            list={[
              {
                title: "전체",
                type: "",
              },
              {
                title: "보호자",
                type: "PARENT",
              },
              {
                title: "자녀",
                type: "CHILD",
              },
              {
                title: "유저 게시판",
                type: "USER",
              },
            ]}
          />
          <TableTop>
            <TableCount text={"항목"} count={pagination.totalCount} />
            <TableSearchBtn>
              <SearchBar
                value={keyword}
                onChange={(e) => {
                  setKeyword(e.target.value);
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    navigate(`${route.story}/1?keyword=${keyword}&tab=${tab}`);
                  }
                }}
                onClick={() => {
                  navigate(`${route.story}/1?keyword=${keyword}&tab=${tab}`);
                }}
              />
              <DelBtn
                onClick={() => {
                  const delIdList = list.filter((item) => item.checked);
                  if (delIdList.length <= 0) {
                    toast("항목을 선택해주세요");
                    return;
                  }
                  setDelIdList([...delIdList]);
                  setDelListModalOpen(true);
                }}
              />
            </TableSearchBtn>
          </TableTop>
          <Table>
            <colgroup>
              <col width="50px" />
              <col width="80px" />
              <col width="90px" />
              <col width="170px" />
              <col width="170px" />
              <col width="70px" />
              <col width="60px" />
              <col width="60px" />
              <col width="78px" />
            </colgroup>
            <thead>
              <Tr style={{ height: "41px", background: "#f2f4f5" }}>
                <Th style={{ paddingLeft: "20px" }}>
                  <Checkbox
                    checked={list.filter((item) => item.checked).length === list.length}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setList(
                          list.map((item) => {
                            return {
                              ...item,
                              checked: true,
                            };
                          })
                        );
                      } else {
                        setList(
                          list.map((item) => {
                            return {
                              ...item,
                              checked: false,
                            };
                          })
                        );
                      }
                    }}
                  />
                </Th>
                <Th>
                  <ThText>작성자</ThText>
                </Th>
                <Th>
                  <ThText>작성게시판</ThText>
                </Th>
                <Th>
                  <ThText>게시물 제목</ThText>
                </Th>
                <Th>
                  <ThText>본문 미리보기</ThText>
                </Th>
                <Th>
                  <ThText>게시 상태</ThText>
                </Th>
                <Th>
                  <ThText>조회수</ThText>
                </Th>
                <Th>
                  <ThText>마지막 수정일</ThText>
                </Th>
                <Th>
                  <ThText style={{ textAlign: "center", paddingRight: "17px" }}>상세보기</ThText>
                </Th>
              </Tr>
            </thead>
            <tbody>
              {list.map((item, index) => {
                return (
                  <Tr style={{ height: "57px", background: "#fff" }} key={index}>
                    <Td style={{ paddingLeft: "20px" }}>
                      <Checkbox
                        checked={item.checked}
                        onChange={() => {
                          item.checked = !item.checked;
                          setList([...list]);
                        }}
                      />
                    </Td>
                    <Td>
                      <TdText>{item.email}</TdText>
                    </Td>
                    <Td>
                      <TdText
                        dangerouslySetInnerHTML={{
                          __html: item.regionName,
                        }}
                      ></TdText>
                    </Td>
                    <Td>
                      <TdText
                        style={{
                          width: "170px",
                          overflow: "hidden",
                          whiteSpace: "nowrap",
                          textOverflow: "ellipsis",
                          wordBreak: "break-all",
                        }}
                      >
                        {item.title}
                      </TdText>
                    </Td>
                    <Td>
                      <TdText
                        style={{
                          width: "170px",
                          overflow: "hidden",
                          whiteSpace: "nowrap",
                          textOverflow: "ellipsis",
                          wordBreak: "break-all",
                        }}
                      >
                        {item.content}
                      </TdText>
                    </Td>
                    <Td>
                      <TableFilterManager
                        onClick={() => {
                          filterOpen === index ? setFilterOpen(-1) : setFilterOpen(index);
                        }}
                        isOpen={filterOpen === index}
                        selectedValue={item.active}
                        list={[
                          {
                            value: true,
                            title: "공개",
                            onClick: () => {
                              setActiveId(item.id);
                              setActiveModalOpen(true);
                            },
                          },
                          {
                            value: false,
                            title: "비공개",
                            onClick: () => {
                              setActiveId(item.id);
                              setDeactiveModalOpen(true);
                            },
                          },
                        ]}
                      />
                    </Td>
                    <Td>
                      <TdText>{item.viewCount}</TdText>
                    </Td>
                    <Td>
                      <TdText>{moment(item.createdAt).format("YYYY/MM/DD")}</TdText>
                    </Td>
                    <Td>
                      <div
                        style={{
                          width: "100%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          paddingRight: "17px",
                        }}
                      >
                        <DetailBtn
                          onClick={() => {
                            navigate(route.story_detail + `/${item.id}`);
                          }}
                        />
                      </div>
                    </Td>
                  </Tr>
                );
              })}
            </tbody>
          </Table>
          <Pagenation
            route={route.story}
            queryString={`keyword=${keyword}&tab=${tab}`}
            currentPage={page}
            totalPages={pagination.totalPages}
            rangeSize={pagination.rangeSize}
            first={pagination.first}
            last={pagination.last}
          />
        </TableLayout>
        {delListModalOpen ? (
          <Modal
            title={modalMsg.delete?.title}
            text={modalMsg.delete?.content}
            setModalOpen={setDelListModalOpen}
            onClick={() => {
              deleteFunc();
            }}
          />
        ) : (
          ""
        )}
        {delModalOpen ? (
          <Modal
            title={modalMsg.delete?.title}
            text={modalMsg.delete?.content}
            setModalOpen={setDelModalOpen}
            onClick={async () => {
              try {
                await AlarmApi.Del(delId);
                setDelModalOpen(false);
                getList();
                toast(toastMsg.delete);
              } catch (error) {
                errorHandler(error);
              }
            }}
          />
        ) : (
          ""
        )}

        {deactiveModalOpen ? (
          <Modal
            title={"비공개하시겠습니까?"}
            setModalOpen={setDeactiveModalOpen}
            onClick={() => {
              activeFunc(false);
            }}
          />
        ) : (
          ""
        )}
        {activeModalOpen ? (
          <Modal
            title={"공개하시겠습니까?"}
            setModalOpen={setActiveModalOpen}
            onClick={() => {
              activeFunc(true);
            }}
          />
        ) : (
          ""
        )}
      </MainLayout>
    </>
  );
}

export default Story;
